var _a;
import { createSlice } from '@reduxjs/toolkit';
var initialState = {
    sideBar: {
        isOpen: true,
        reason: 'user'
    },
    chatMachineStatus: 'off',
    chatApiStatus: undefined,
    shouldNavigateToChats: false
};
var commonSlice = createSlice({
    name: 'common',
    initialState: initialState,
    reducers: {
        setSideBarState: function (state, action) {
            state.sideBar = action.payload;
        },
        setCurrentCompany: function (state, action) {
            state.currentCompany = action.payload;
        },
        setChatMachineStatus: function (state, action) {
            state.chatMachineStatus = action.payload;
            if (action.payload === 'starting' || action.payload === 'stopping')
                state.chatApiStatus = 'off';
        },
        setChatApiStatus: function (state, action) {
            state.chatApiStatus = action.payload;
        },
        setShouldNavigateToChats: function (state, action) {
            state.shouldNavigateToChats = action.payload;
        }
    }
});
export default commonSlice.reducer;
export var setSideBarState = (_a = commonSlice.actions, _a.setSideBarState), setCurrentCompany = _a.setCurrentCompany, setChatMachineStatus = _a.setChatMachineStatus, setChatApiStatus = _a.setChatApiStatus, setShouldNavigateToChats = _a.setShouldNavigateToChats;
